import React from 'react';
import {
  VodafoneLogo,
} from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/header/brand.css';
import { Link } from 'react-router-dom';


const Brand = () => {

  const deleteTabSession = () => {
    const keysToRemove = ['BucketTabSession', 'MyBucketTabSession'];
    // delete all tab array from sessionStorage
    keysToRemove.forEach((tabkey) => {
      window.sessionStorage.removeItem(tabkey);
    });
  };

  return (
    <Link
      to="/"
      className="brand"
      onClick={deleteTabSession}
    >
      <div className="brand-svg">
        <VodafoneLogo />
      </div>
      <h1 className="brand-title">ACE Portal</h1>
    </Link>
  );
};

export { Brand };
